/**
 * Query keys centralizzate per le query TanStack Query relative al controllo olio friggitrici.
 * Usa questa struttura per garantire invalidazione consistente della cache.
 */
/**
 * Query keys centralizzate per le query TanStack Query relative al controllo olio friggitrici.
 * Usa questa struttura per garantire invalidazione consistente della cache.
 */
export const oilQueryKeys = {
  all: ['oil'] as const,
  fryerList: () => ['oil', 'fryer-list'] as const,
  dayRecords: (date: string) => ['oil', 'day-records', date] as const,
  calendar: (from: string, to: string) => ['oil', 'calendar', from, to] as const,
  fryerHistory: (fryerId: string, from: string | null, to: string | null) =>
    ['oil', 'fryer-history', fryerId, from, to] as const,
};
